import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Grid, Tooltip } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";

const todate = new Date();
var fromdate = todate.getFullYear() - 1 + '/04/01';
//const fromdate = new Date().setFullYear(new Date().getFullYear(),0);
//const fromdate = new Date(new Date().setDate(new Date().getDate() - 30));

const QuotationLostAnalysis = () => {
    const [QuotationNo, setQuotationNo] = useState('');
    const [Model, setModel] = useState('');
    const [Customer, setCustomer] = useState('');
    const [Industry, setIndustry] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState('');
    const [IndustryID, setIndustryID] = useState('');
    const [QuotationStage, setQuotationStage] = useState('Closed')
    const [QuotationStages, setQuotationStages] = useState('Expired')
    const [AccName, setAccName] = useState('');
    const [responseAccount, fetchAccountData] = UseFetchData();
    const [AccountOptions, setAccountOptions] = useState([]);
    const [Category1, setCategory1] = useState('');
    const [Category2, setCategory2] = useState('');
    const [Category3, setCategory3] = useState('');
    const [Category4, setCategory4] = useState('');
    const [Count, setCount] = useState('');
    const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    //     const [CompanyID, setCompanyID] = useState('');
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [IndustryIDcmb, setIndustryIDcmb] = useState([]);
    const [CountryIDcmb, setCountryIDcmb] = useState([]);
    const [ComboSalesExecutive, setComboSalesExecutive] = useState([]);
    const [ComboCompany, setComboCompany] = useState([]);
    const [ProductIDcmb, setProductIDcmb] = useState([]);
    const [Countrycmb, setCountrycmb] = useState([]);
    const [ProductID, setProductID] = useState('');
    const [CountryID, setCountryID] = useState('');
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [SearchMode, setSearchMode] = useState("SEARCH");

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["Productcmb"] !== undefined) {
                setProductIDcmb(ComboDataResponse["Productcmb"]);
            }
            if (ComboDataResponse["SalesExecutive"] !== undefined) {
                setComboSalesExecutive(ComboDataResponse["SalesExecutive"]);
            }
            if (ComboDataResponse["cmbIndustry"] !== undefined) {
                setIndustryIDcmb(ComboDataResponse["cmbIndustry"]);

            }
            if (ComboDataResponse["cmbCountry"] !== undefined) {
                setCountryIDcmb(ComboDataResponse["cmbCountry"]);

            }

        }
    }, [ComboDataResponse]);

    const GetComboData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", "");
        // bodyFormData.append("ProductCat1ID", "");
        // bodyFormData.append("ProductCat2ID", "");
        // bodyFormData.append("ProductCat3ID", "");
        fetchComboData("QuotationAnalysis/ComboData", bodyFormData);
    };



    const PopulateData = () => {
        // debugger;
        var bodyFormData = new FormData();
        var SalesTeamList = "",
            AccoName = "";
        if (AccountName !== undefined) {
            AccoName = AccountName.AccountName;
        }
        bodyFormData.append("Model", Model);
        bodyFormData.append("AccountName", AccountName.List);
        bodyFormData.append("IndustryID", IndustryID);
        bodyFormData.append("SearchString", AccName);
        bodyFormData.append("QuotationNo", QuotationNo);
        bodyFormData.append("SalesExecutiveID", SalesExecutiveID);
        bodyFormData.append("QuotationStage", "Closed");
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("CountryID", CountryID);
        fetchData("QuotationLostAnalysis/ListQuotationLostAnalysis", bodyFormData);
    };

    const AccountData = () => {
        var bodyFormData = new FormData();
        fetchAccountData("QuotationLostAnalysis/ComboData", bodyFormData);
    }

    useEffect(() => {
        const gridCols = [
            {
                field: "QuotationNo",
                headerName: "QutNo",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 130,
            },
            {
                field: "QuotationDate",
                headerName: "QUT Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "AccountName",
                headerName: "Account",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 230,
            },
            // {
            //     field: "ContactName",
            //     headerName: "Customer",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 160,
            //     renderCell: (params) => (
            //         <Tooltip title={params.row.ContactName} >
            //             <span className="table-cell-trucate">{params.row.ContactName}</span>
            //         </Tooltip>
            //     ),
            // },
            {
                field: "CompanyName",
                headerName: "CompanyName",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 230,
            },
            {
                field: "QuotationLostReasonCode",
                headerName: "LostReasonCode",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "QuotationLostWonBy",
                headerName: "QutLostBy",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
            },

            {
                field: "ProductCat1",
                headerName: "ProductCat",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "Industry",
                headerName: "Industry",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "Country",
                headerName: "Country",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 140,
            },
        ];
        setColumns(gridCols);
        // debugger;
        setRows(response);
        setCount(response.length);
    }, [response]);

    useEffect(() => {
        GetComboData();
        PopulateData();
        AccountData();
    }, []);

    const onACCChange = (event, newValue) => {
        // debugger;
        setAccountName(newValue);
        setAccountID(newValue.id);
    }

    useEffect(() => {
        // debugger;
        if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
            setAccountOptions(responseAccount['cmbAccount']);
        }
    }, [responseAccount['cmbAccount']]);

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['ProductName', 'QuotationStage', 'QuotationDate', 'ContactName', 'ModelCode', 'Description', 'Unit', 'Quantity', 'Rate', 'Currency', 'ConvFactor', 'RateINR', 'Amount']
                }} />
            </GridToolbarContainer>
        );
    }

    return <div >
        <Grid container direction="row" >
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 6 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </div>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 7 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </div>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 22, width: 100 }} >
                <BiztranControls.Autocomplete
                    label="Account Name"
                    options={AccountOptions}
                    style={{ marginLeft: 7, width: "180px" }}
                    onChange={onACCChange}
                    value={AccName}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Select
                    label="Industry"
                    id="Industry"
                    options={IndustryIDcmb}
                    onChange={(e) => setIndustryID(e.target.value)}
                />
            </Grid>
        </Grid>
        <Grid container direction="row" style={{ marginTop: 7 }} >
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Country"
                    id="Country"
                    options={CountryIDcmb}
                    onChange={(e) => setCountryID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Sales Executive"
                    id="SalesExecutive"
                    options={ComboSalesExecutive}
                    onChange={(e) => setSalesExecutiveID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Input
                    label="Quotation No"
                    id="QuotationNo"
                    style={{ width: "180px" }}
                    onChange={(e) => setQuotationNo(e.target.value)}
                />
            </Grid>
            <label style={{ fontWeight: 'bold', width: 30, marginTop: 15 }}>{Count}</label>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Button
                    text="Populate"
                    startIcon={<SearchIcon />}
                    onClick={() => {
                        PopulateData();
                    }}
                />
            </Grid>
        </Grid>
        <BiztranControls.DataGrid
            headerHeight={34}
            rowHeight={25}
            rows={rows}
            columns={columns}
            checkboxSelection={false}
            // autoHeight={true}
            Height="400px"
            Width="100%"
            components={{ Toolbar: CustomToolbar, }}
        />
    </div>
};

export default QuotationLostAnalysis;